// extracted by mini-css-extract-plugin
export var buttonWrap = "HeaderMainMenu-module--buttonWrap--9241b";
export var desktopButtonsWrap = "HeaderMainMenu-module--desktopButtonsWrap--a7b56";
export var gapFix = "HeaderMainMenu-module--gapFix--81393";
export var headerDivider = "HeaderMainMenu-module--headerDivider--aec03";
export var loginButton = "HeaderMainMenu-module--loginButton--ad78b";
export var logo = "HeaderMainMenu-module--logo--e3ee9";
export var menuBodyWrap = "HeaderMainMenu-module--menuBodyWrap--6ee29";
export var menuBtnPart = "HeaderMainMenu-module--menuBtnPart--19a4f";
export var menuExpander = "HeaderMainMenu-module--menuExpander--53e6a";
export var menuList = "HeaderMainMenu-module--menuList--7453a";
export var mobileButtonsWrap = "HeaderMainMenu-module--mobileButtonsWrap--3105c";
export var mobileMenu = "HeaderMainMenu-module--mobileMenu--a636e";
export var mobileMenuOpen = "HeaderMainMenu-module--mobileMenuOpen--50d21";
export var mobileMenuWrap = "HeaderMainMenu-module--mobileMenuWrap--18627";
export var root = "HeaderMainMenu-module--root--ffe55";
export var sandwichBtn = "HeaderMainMenu-module--sandwichBtn--e9e58";
export var signupButton = "HeaderMainMenu-module--signupButton--48bfc";